import React from "react";
import TextField from "@material-ui/core/TextField";
import { withStyles } from "@material-ui/core";

const CssTextField = withStyles({
  root: {
    "& input": {
      color: "var(--primary-text-color)",
    },
    "& textarea": {
      color: "var(--primary-text-color)",
    },
    "& label": {
      color: "var(--grey-5)",
    },
    "& label.Mui-focused": {
      color: "var(--blue-dark)",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "green",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "var(--grey-5)",
      },
      "&:hover fieldset": {
        borderColor: "var(--blue-dark)",
      },
      "&.Mui-focused fieldset": {
        borderColor: "var(--blue-dark)",
      },
    },
    "& .MuiFormHelperText-root": { color: "var(--grey-5)" },
  },
})(TextField);

const Input = ({ ...props }) => {
  return <CssTextField {...props} />;
};

export default Input;
